/*
 *
 * getAnnouncementPage Function
 *
 */

import React from 'react';
import AnnouncementPage from "./AnnouncementPage";

export default function getAnnouncementPage(accountId, props) {
    switch (accountId) {
        default:
            return (
                <AnnouncementPage {...props} />
            );
    }
}
